import * as Effects from 'redux-saga/effects'
import { IToggleUpdateReservation } from '../../../actions/bookingCalendar/reservationModal/toggleReservationModal'
import { callFetch } from '../../../actions/fetch'
import invoiceAccepted from '../../../actions/invoices/invoiceAccepted'
import invoiceRejected from '../../../actions/invoices/invoiceRejected'
import requestInvoice, {
  IRequestInvoice,
} from '../../../actions/invoices/requestInvoice'
import toggleInvoiceLoading from '../../../actions/invoices/toggleInvoiceLoading'
import { IInvoice } from '../../../models/Invoice'
import fetchInvoice from '../../../models/Invoice/fetchInvoice'
import { ReservationModalActions } from '../../../reducers/bookingCalendar/actionNames'
import { InvoiceActions } from '../../../reducers/invoice/actionNames'
import { ActionNames } from '../../../utils/FetchActionsName'
import fetchActionsName from '../../../utils/FetchActionsName/fetchActionsName'

function* loadInvoice(action: IToggleUpdateReservation) {
  if (action.toggle) {
    yield Effects.put(requestInvoice(action.id))
  }
}

function* request(action: IRequestInvoice) {
  try {
    yield Effects.put(toggleInvoiceLoading(true))
    const actionNames = fetchActionsName(ActionNames.FetchInvoice)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, fetchInvoice),
      ),
    ])

    const invoice: IInvoice = yield Effects.call(service, action.id)

    yield Effects.put(invoiceAccepted(invoice, action.id))
    yield Effects.put(toggleInvoiceLoading())
  } catch {
    yield Effects.put(toggleInvoiceLoading())
    yield Effects.put(invoiceRejected())
  }
}

export default function*() {
  yield Effects.takeEvery(
    ReservationModalActions.ToggleUpdateReservationModalRedux,
    loadInvoice,
  )
  yield Effects.takeEvery(InvoiceActions.Request, request)
}
